import { action as apiAction } from 'api/Api'
import {
  addCardRelation
} from 'store/redux/cardRelations'
import sweetalert from 'sweetalert2'
import { optimisticDispatch } from 'utils/sagas'

const findChild = (id, cardRelationsById, childId) => {
  let child = null

  if (!cardRelationsById[id]) return null

  const childIds = cardRelationsById[id].childIds

  let i
  const length = childIds.length
  for (i = 0; i < length; i++) {
    if (childIds[i] === childId) {
      child = childId
      break
    }

    const _child = findChild(childIds[i], cardRelationsById, childId)

    if (_child) {
      child = _child
      break
    }
  }

  return child
}

async function displayCycleError (state) {
  try {
    await sweetalert({
      text: state.kanbo.locale.messages['CARD_RELATION_PARENT_CHILD_CYCLE_ERROR'],
      type: 'info'
    })
  } catch (e) {}
}

async function displayDuplicateRelationAlert (state) {
  try {
    await sweetalert({
      text: state.kanbo.locale.messages['CARD_RELATION_ADD_DUPLICATE'],
      type: 'info'
    })
  }
  catch (e) {}
}

type Payload = {
  cardId: number
  parentId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId, parentId } = payload

  const state = getState()

  const cardRelationsById = state.kanbo.cardRelations.byId

  if (findChild(cardId, cardRelationsById, parentId)) {
    await displayCycleError(state)

    return
  }

  const optimisticAction = optimisticDispatch(dispatch, [
    addCardRelation({
      id: parentId,
      childIds: [cardId]
    }),
    addCardRelation({
      id: cardId,
      parentIds: [parentId],
    })
  ])

  try {
    await apiAction('AddCardParent', {
      cardId,
      cardParentId: parentId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code === 1102) { // Cycle
      await displayCycleError(getState())
    } else if (error.code === 1100) { // CardRelationExistsException
      await displayDuplicateRelationAlert(getState())
    } else if (
      error.code !== 1101 && // CardHasParentEqualException
      error.code !== 1103 // CardRelationCannotPointAtItselfException
    ) {
      throw error
    }
  }
}
